import React from 'react';

import { NoColour } from '../../../../../Common/Buttons/Icons';
import { validColour } from '../../../../../../Helpers/StringHelper';
import { P3, Heading6, CaptionMedium, P3Bold, P3Link, Heading5, CaptionSmall } from '../../../../../Common/DesignSystem/Text';
import Button from '../../../../../Common/DesignSystem/Button';
import colours from '../../../../../Common/DesignSystem/Colours';
import Icon from '../../../../../Common/DesignSystem/Icons/Icon';

export const VehicleInformationCard = ({ vehicle, placeholderImage, editVehicle, toInputRef, match }) => {
	const iconContainerStyle = { marginRight: 8, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue };

	const imageError = (e) => {
		e.target.src = placeholderImage.includes("images/") ? placeholderImage : "images/" + placeholderImage
	}

	const openCustomerView = () => {
		window.open(("/eu-vehicle/" + match.params.v_id), '_blank', 'noopener,noreferrer');
	}

	const openSpecSheet = (specSheetUrl) => {
		const win = window.open(specSheetUrl);
		win.focus();
	}

	return (
		<div className="overlay_header_bordered">
			<div className="profile-info-container">
				<div className="mobile-hidden-f2" style={{ height: '100%' }}>
					<div style={{ display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'space-between' }}>
						<div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
							<div className="overlay_header_image_container" style={{ height: 'auto', borderRadius: 8, overflow: 'hidden' }}>
								{vehicle.photoUrl ? (
									<img onError={imageError} className="overlay_header_image" style={{ height: 'auto' }} src={vehicle.photoUrl} />
								) : (
									<img className="overlay_header_image" style={{ width: '300px', height: 'auto' }} src={placeholderImage.includes("images/") ? placeholderImage : "images/" + placeholderImage} />
								)}
							</div>
							{vehicle.licensePlate && (
								<div className="license-plate-container-blue" style={{ width: 135, alignSelf: 'center', zIndex: 88, marginTop: -13 }}>
									<div className="ds-statuscard-header-blue" style={{ display: 'flex', flex: 1, justifyContent: 'center', flexDirection: 'row', alignItems: 'center' }}>
										<CaptionSmall style={{ color: colours.primary.white, fontWeight: 'bold', paddingTop: 1, paddingBottom: 1 }}>LICENSE PLATE</CaptionSmall>
									</div>
									<div style={{ display: 'flex', flex: 1, justifyContent: 'center', flexDirection: 'row', alignItems: 'center', height: 36, backgroundColor: colours.primary.white }}>
										<Heading5>{vehicle.licensePlate}</Heading5>
									</div>
								</div>
							)}
							{vehicle.uniqueTag && (
								<div style={{ flexDirection: 'row', display: 'flex', alignSelf: 'center', alignItems: 'center', marginTop: 8 }}>
									<CaptionMedium style={{ color: colours.primary.grey02, fontWeight: '700' }}>UNIQUE TAG:</CaptionMedium>
									<P3Bold style={{ marginLeft: 8 }}>{vehicle.uniqueTag}</P3Bold>
								</div>
							)}
						</div>
						<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 16 }}>
							<div onClick={openCustomerView} style={{ display: 'flex', flex: 1, justifySelf: 'flex-end', marginRight: 4 }}>
								<Button tertiary label="Customer View" leading_ic="User" />
							</div>
						</div>
					</div>
				</div>
				<div style={{ display: 'flex', flex: 2, paddingLeft: 12, flexDirection: 'column' }}>
					<div style={{ justifyContent: 'space-between', flexDirection: 'row', display: 'flex', flex: 1 }}>
						<Heading6 style={{ color: colours.primary.grey01 }}>
							{vehicle.year} {vehicle.make} {vehicle.modelName} {vehicle.trim}
						</Heading6>
						<Button small tertiary label="Edit" leading_ic="Edit" color={colours.primary.grey02} onClick={editVehicle} />
					</div>
					<div style={{ marginTop: 8 }}>
						<P3 style={{ color: colours.primary.grey02 }}>{vehicle.vin}</P3>
					</div>
					<div style={{ marginTop: 16, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center' }}>
						<div>
							<div style={{ flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center' }}>
								<Icon size={24} name="Mileage" style={iconContainerStyle} />
								<CaptionMedium style={{ color: colours.primary.grey02 }}>Mileage:</CaptionMedium>
							</div>
							<div style={{ flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 12 }}>
								{validColour(vehicle.exteriorColor) ? (
									<div style={{ height: 24, minWidth: 24, borderRadius: 8, backgroundColor: vehicle.exteriorColor, border: `solid 1px ${colours.primary.grey04}`, marginRight: 8 }}></div>
								) : (
									<div style={{ height: 24, width: 24, marginRight: 6, marginLeft: 2 }}> {NoColour("vehicle_color_icon")} </div>
								)}
								<CaptionMedium style={{ color: colours.primary.grey02 }}>Exterior Colour:</CaptionMedium>
							</div>
							<div style={{ flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 12 }}>
								{validColour(vehicle.interiorColor) ? (
									<div style={{ height: 24, minWidth: 24, borderRadius: 8, backgroundColor: vehicle.interiorColor, border: `solid 1px ${colours.primary.grey04}`, marginRight: 8 }}></div>
								) : (
									<div style={{ height: 24, width: 24, marginRight: 6, marginLeft: 2 }}> {NoColour("vehicle_color_icon")} </div>
								)}
								<CaptionMedium style={{ color: colours.primary.grey02 }}>Interior Colour:</CaptionMedium>
							</div>
							<div style={{ flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 12 }}>
								<Icon size={24} name="Keys" style={iconContainerStyle} />
								<CaptionMedium style={{ color: colours.primary.grey02 }}>Keys:</CaptionMedium>
							</div>
							<div style={{ flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 12 }}>
								<Icon size={24} name="Specsheet" style={iconContainerStyle} />
								<CaptionMedium style={{ color: colours.primary.grey02 }}>Spec Sheet:</CaptionMedium>
							</div>
						</div>
						<div>
							<div style={{ height: 24, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center' }}>
								<P3Bold>{new Intl.NumberFormat('en-CA').format(vehicle.odometer)} KM</P3Bold>
							</div>
							<div style={{ height: 24, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 12 }}>
								<P3Bold>
									{vehicle.exteriorColor ?
										vehicle.exteriorColor
										:
										<Button
											tertiary
											small
											label="Add Exterior Colour"
											onClick={() => {
												editVehicle();
												toInputRef('exteriorColourRef');
											}}
											leading_ic="AddCircle"
											style={{ padding: 0 }}
										/>
									}
								</P3Bold>
							</div>
							<div style={{ height: 24, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 12 }}>
								<P3Bold>
									{vehicle.interiorColor ?
										vehicle.interiorColor
										:
										<Button
											tertiary
											small
											label="Add Interior Colour"
											onClick={() => {
												editVehicle();
												toInputRef('interiorColourRef');
											}}
											leading_ic="AddCircle"
											style={{ padding: 0 }}
										/>
									}
								</P3Bold>
							</div>
							<div style={{ height: 24, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 12 }}>
								<P3Bold>
									{vehicle.keys ?
										parseInt(vehicle.keys)
										:
										<Button tertiary small label="Add Keys" onClick={editVehicle} leading_ic="AddCircle" style={{ padding: 0 }} />
									}
								</P3Bold>
							</div>
							<div style={{ height: 24, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 12 }}>
								<P3Bold>
									{vehicle.specSheetUrl ? (
										<a className="no-padding" onClick={() => openSpecSheet(vehicle.specSheetUrl)} style={{ cursor: 'pointer', display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'flex-start' }}>
											<P3Link>Open Spec Sheet</P3Link>
											<span><Icon name="ChevronRight" size={16} style={{ color: colours.primary.blue }} /></span>
										</a>
									) : (
										<Button tertiary small label="Add Spec Sheet" onClick={editVehicle} leading_ic="AddCircle" style={{ padding: 0 }} />
									)}
								</P3Bold>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}